// extracted by mini-css-extract-plugin
export default {"StandingdHeader":"StandingsHeader_StandingdHeader__Z0fEW","Bold":"StandingsHeader_Bold__0qZCm"};